import { Paragraph2 } from '@cian/ui-kit/typography';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { plural } from '@cian/utils';
import * as React from 'react';

import styles from './MoreAreasLink.css';
import { AreaLink } from '../AreaLink';

interface IMoreAreasLinkProps {
  href: string;
  count: number;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const AREA_PLURAL: [string, string, string] = ['площадь', 'площади', 'площадей'];

export const MoreAreasLink: React.FC<IMoreAreasLinkProps> = ({ href, count, onClick }) => {
  const text = `Ещё ${count} ${plural(count, AREA_PLURAL)}`;

  return (
    <AreaLink href={href} onClick={onClick} className={styles['root']}>
      <Paragraph2 color="accent-main-primary">{text}</Paragraph2>
      <IconActionChevronRightSmall16 color="icon-main-default" />
    </AreaLink>
  );
};

MoreAreasLink.displayName = 'MoreAreasLink';
